import { render, staticRenderFns } from "./ActionCableStatus.vue?vue&type=template&id=1bd2d3a0&scoped=true&"
import script from "./ActionCableStatus.vue?vue&type=script&lang=js&"
export * from "./ActionCableStatus.vue?vue&type=script&lang=js&"
import style0 from "./ActionCableStatus.vue?vue&type=style&index=0&id=1bd2d3a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd2d3a0",
  null
  
)

export default component.exports